<template>
  <div class="page-content">
    <page-template
      ref="warningtable"
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
    ></page-template>
  </div>
</template>
<script>
import pageTemplate from "@/components/template/pageTemplate";
import api from "@/config/api";
import userPower from "@/mixin/userPower";

export default {
  mixins: [userPower],
  components: {
    pageTemplate,
  },
  data() {
    return {
      dialogVisibility: false,
      searchOptions: {
        simple: [
          {
            label: "门店名称",
            type: "select",
            prop: "storeId",
            data: [],
            span:12,
          },

        ],
        complex: [
           {
             label: "类别",
             type: 'cascaderMultiple',
             prop: 'goodsCategoryIds',
             valueKey: 'value',
             data: [],
             span: 12,
             change: this.typeChange,
             url: api.archives.getCategoryTree,
           },
         {
            label: '供应商',
            type: 'select',
            prop: 'supplierId',
            span: 12,
            data: [],
            url: api.archives.supplier,
          },
          {
            label: "状态",
            prop: "status",
            type: "select",
             data: [{label:'库存不足',value:10},{label:'库存过剩',value:20},{label:'过期预警',value:30},],
            span:12,
          },
        ],
      },
      // 表格信息配置
      tableOptions: {
         indexShow: true,
        columns: [
          {
            label: "商品名称",
            prop: "goodsName",
            width: "150",
            align: "center",
          },
          {
            label: "条码",
            prop: "barCode",
            width: "190",
            align: "center",
          },
          {
            label: "规格",
            prop: "specs",
            width: "80",
            align: "center",
            enumData: this.$utils.getCacheStatus("sysGuideMap.commissionType"),
          },
          {
            label: "商品分类",
            prop: "goodsCategoryName",
            width: "120",
            align: "center",
            enumData: this.$utils.getCacheStatus("sysUser.status"),
          },
          {
            label: "供应商",
            prop: "supplierName",
            width: "150",
            align: "center",
          },
          {
            label: "现有库存",
            prop: "inventoryNum",
            width: "100",
            align: "center",
          },
          {
            label: "单位",
            prop: "unitName",
            width: "80",
            align: "center",
          },
          {
            label: "库存上限",
            prop: "highInventory",
            width: "100",
            align: "center",
          },
          {
            label: "库存下线",
            prop: "lowInventory",
            width: "100",
            align: "center",
          },
          {
            label: "到期日期",
            prop: "dueDate",
            width: "150",
            align: "center",
          },
          {
            label: "保质情况",
            prop: "guaranteeDate",
            width: "150",
            align: "center",
          },
          {
            label: "状态",
            prop: "statusValue",
            width: "150",
            align: "center",
          },
        ],
        url: api.report.warehouseWaring,
      },
    };
  },
  created(){
      this.editStyle()
      this.allStore()
      this.setStore(this.searchOptions.simple);
  },
  methods: {
     editStyle(){

          //  let warning=this.$refs["warningtable"].$refs["tableTemp"].tableData;console.log(warning)


       //  let warning=document.querySelectorAll(".el-table__body .el-table__row")[9]
         let warning = this.tableOptions.columns.filter(item=>item.prop=='statusValue')[0]

       // let warning=document.querySelectorAll(".el-table__body tbody .el-table__row .el-table__row")

     },
      allStore(){
          let mes=[]
          mes.unshift({name:"全部门店",value:""});
          this.$axios.fetchPost(api.system.seStore+'/list').then(data=>{
            if(data.code===200){
            data.data.unshift({name:"全部门店",value:""});
            this.searchOptions.simple.filter(item=>item.prop==="storeId")[0].data=data.data;
          }
          })
       }
   }
}
</script>
<style scoped>
  /* >>>.el-table__body .el-table__row span{
      border: 1px solid red;
  } */
</style>




// WEBPACK FOOTER //
// src/page/report/inventory/Warning.vue